import { RouteConfig } from "vue-router";

export const REmployerCandidateInvite: RouteConfig = {
  name: "InviteCandidate",
  path: "invite",
  component: () =>
    import(
      /* webpackChunkName: "candidate-invite" */
      "./VCandidateInvite.vue"
    ),
  meta: {
    title: "Invite Your Candidate For a Visa Eligibility Check",
    icon: "book-outline",
    backLink: "/candidates",
    hide: true,
  },
};
